import { fetchWithAuth, getCSRFToken } from '../auth';

const API = process.env.REACT_APP_ICC_TOOL_API_HOST;

const jsonHeaders = () => ({
    'X-CSRFToken': getCSRFToken(),
    'Content-Type': 'application/json',
});

export const getAssetMakes = () =>
    fetchWithAuth(`${API}asset-makes/`, { method: 'GET', credentials: 'include' });

export const createAssetMake = (data) =>
    fetchWithAuth(`${API}asset-makes/`, {
        method: 'POST',
        headers: jsonHeaders(),
        credentials: 'include',
        body: JSON.stringify(data),
    });

export const updateAssetMake = (id, data) =>
    fetchWithAuth(`${API}asset-makes/${id}/`, {
        method: 'PATCH',
        headers: jsonHeaders(),
        credentials: 'include',
        body: JSON.stringify(data),
    });

export const deleteAssetMake = (id) =>
    fetchWithAuth(`${API}asset-makes/${id}/`, {
        method: 'DELETE',
        headers: { 'X-CSRFToken': getCSRFToken() },
        credentials: 'include',
    });

// `makeId` is optional — omit it to fetch the full model catalog.
export const getAssetModels = (makeId) =>
    fetchWithAuth(makeId ? `${API}asset-models/?make=${makeId}` : `${API}asset-models/`, {
        method: 'GET',
        credentials: 'include',
    });

export const createAssetModel = (data) =>
    fetchWithAuth(`${API}asset-models/`, {
        method: 'POST',
        headers: jsonHeaders(),
        credentials: 'include',
        body: JSON.stringify(data),
    });

export const updateAssetModel = (id, data) =>
    fetchWithAuth(`${API}asset-models/${id}/`, {
        method: 'PATCH',
        headers: jsonHeaders(),
        credentials: 'include',
        body: JSON.stringify(data),
    });

export const deleteAssetModel = (id) =>
    fetchWithAuth(`${API}asset-models/${id}/`, {
        method: 'DELETE',
        headers: { 'X-CSRFToken': getCSRFToken() },
        credentials: 'include',
    });
